import { Route, Routes } from "react-router-dom";
import ReviewsPage from "../../pages/shared-pages/reviews/ReviewsPage";

export default function ReviewNav() {
    return (
        <Routes>

            <Route path="/" element={<ReviewsPage />} />


        </Routes>
    )
}
